import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import IdleTimeout from '../IdleTimeout'

import {
  setLastAccessed,
  setTimeOutNotice,
} from '../../../../modules/auth/actions/creators'

const mapStateToProps = reduxState => {
  const { auth } = reduxState

  const { accessToken, lastAccessed, showTimeOutNotice } = auth

  return {
    accessToken,
    lastAccessed,
    showTimeOutNotice,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setLastAccessed,
      setTimeOutNotice,
    },
    dispatch,
  )

const ConnectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(IdleTimeout)

export default ConnectedComponent
